/* Extraction d'informations patient depuis un texte collé.
   100% locale par expressions régulières — AUCUNE IA. */

const LANGUES = ['français', 'francais', 'anglais', 'allemand', 'luxembourgeois', 'portugais', 'italien', 'espagnol', 'néerlandais', 'neerlandais', 'arabe', 'russe', 'ukrainien', 'serbe', 'croate', 'polonais', 'roumain', 'turc', 'chinois', 'grec', 'hongrois',
  'lëtzebuergesch', 'letzebuergesch', 'luxembourgish', 'deutsch', 'english', 'português', 'portugues', 'español', 'espanol', 'italiano', 'română', 'romana', 'русский', 'العربية', '中文', 'nederlands', 'polski', 'türkçe', 'ελληνικά', 'magyar', 'українська', 'srpski', 'hrvatski'];

const setIf = (out, k, v) => { if (v && !out[k]) out[k] = String(v).trim(); };

const parseNomPrenom = (s, out) => {
  const mots = s.split(/\s+/).filter(Boolean);
  const maj = mots.filter(m => m.length > 1 && m === m.toUpperCase() && /[A-ZÀ-Ý]/.test(m));
  if (maj.length && maj.length < mots.length) {
    setIf(out, 'nom', maj.join(' '));
    setIf(out, 'prenom', mots.filter(m => !maj.includes(m)).join(' '));
  } else if (mots.length >= 2) {
    setIf(out, 'nom', mots[0]);
    setIf(out, 'prenom', mots.slice(1).join(' '));
  } else if (mots.length === 1) {
    setIf(out, 'nom', mots[0]);
  }
};

const setDate = (out, d, m, y) => {
  setIf(out, 'date_naissance', `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`);
  setIf(out, 'date_naissance_fr', `${String(d).padStart(2, '0')}/${String(m).padStart(2, '0')}/${y}`);
};

const classifyLabeled = (key, value, out) => {
  const k = key.toLowerCase().trim();
  const put = (field, v) => { setIf(out, field, v); return true; };
  if (/pr[ée]nom/.test(k)) return put('prenom', value);
  if (/^nom|nom de famille|nom patient/.test(k)) return put('nom', value);
  if (/naissance|^n[ée]\(?e?\)?( le)?$/.test(k)) {
    const m = value.match(/(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{4})/);
    if (m) setDate(out, m[1], m[2], m[3]);
    return true;
  }
  if (/^(sexe|sex|genre|civilit)/.test(k)) { out.sexe = /^(f|w|mme|madame|mlle)/i.test(value.trim()) ? 'F' : 'M'; return true; }
  if (/matricule|cns|s[ée]cu|identifiant/.test(k)) return put('matricule', value.replace(/\D/g, ''));
  if (/t[ée]l|gsm|portable|mobile/.test(k)) return put('telephone', value);
  if (/mail|courriel/.test(k)) return put('email', value);
  if (/adresse/.test(k)) return put('adresse', value);
  if (/langue/.test(k)) return put('langue', value);
  if (/m[ée]tier|profession/.test(k)) return put('profession', value);
  if (/m[ée]decin|correspondant|dr traitant|prescripteur/.test(k)) return put('medecin', value.replace(/^dr\.?\s*/i, ''));
  if (/lien|dossier|url/.test(k)) return put('lien', value);
  const rf = k.match(/r[ée]fraction\s*(od|og)/);
  if (rf) return put('refraction_' + rf[1], value);
  return false;
};

export const parsePatientColle = (txt) => {
  const out = {};
  const reste = [];
  const lines = (txt || '').split('\n').map(l => l.trim()).filter(Boolean);

  for (const line of lines) {
    // 1. URL
    const url = line.match(/https?:\/\/\S+/i);
    if (url) { setIf(out, 'lien', url[0]); continue; }
    // 2. Ligne libellée "clé : valeur"
    const lab = line.match(/^([A-Za-zÀ-ÿ'’ °()./-]{2,35})\s*:\s*(.+)$/);
    if (lab && classifyLabeled(lab[1], lab[2], out)) continue;
    // 3. E-mail
    const email = line.match(/[\w.+-]+@[\w-]+\.[\w.]{2,}/);
    if (email) { setIf(out, 'email', email[0]); continue; }
    // 4. Civilité + nom
    const civ = line.match(/^(monsieur|madame|mademoiselle|mme|mlle|mr|m\.)\s+(.+)/i);
    if (civ) {
      out.civilite = civ[1];
      out.sexe = /^(madame|mme|mlle|mademoiselle)/i.test(civ[1]) ? 'F' : 'M';
      parseNomPrenom(civ[2], out);
      continue;
    }
    // 5. Date de naissance
    const date = line.match(/(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{4})/);
    if (date && line.replace(date[0], '').replace(/n[ée]e?\)?(\s*le)?\s*:?/i, '').trim().length < 4) {
      setDate(out, date[1], date[2], date[3]);
      continue;
    }
    // 6. Matricule CNS (11 à 13 chiffres)
    const dig = line.replace(/\D/g, '');
    if (/^[\d\s]+$/.test(line) && dig.length >= 11 && dig.length <= 13) { setIf(out, 'matricule', dig); continue; }
    // 7. Téléphone
    if ((/^(\+|00)/.test(line) || /^t[ée]l/i.test(line)) && dig.length >= 8 && dig.length <= 15) {
      setIf(out, 'telephone', line.replace(/^t[ée]l[ée]?(phone)?\.?\s*:?\s*/i, ''));
      continue;
    }
    // 8. Adresse
    if ((line.includes(',') && /\d/.test(line)) || /^\d+[, ].*(rue|all[ée]e|avenue|av\.|boulevard|bd|route|chemin|place|impasse|mont[ée]e|zone|cit[ée])/i.test(line)) {
      setIf(out, 'adresse', line);
      continue;
    }
    // 9. Langue(s)
    const langs = line.split(/[,/;+]+/).map(s => s.trim()).filter(Boolean);
    if (langs.length && langs.every(l => LANGUES.includes(l.toLowerCase()))) { setIf(out, 'langue', line); continue; }
    // 10. Nom de personne (patient si pas encore trouvé, sinon médecin correspondant)
    const mots = line.split(/\s+/).filter(Boolean);
    const nameLike = mots.length >= 2 && mots.length <= 5 && mots.every(m => /^[A-Za-zÀ-ÿ'’.-]+$/.test(m));
    if (nameLike) {
      if (!out.nom) { parseNomPrenom(line, out); continue; }
      if (!out.medecin && (/^dr\b/i.test(line) || mots.some(m => m.length > 1 && m === m.toUpperCase()))) {
        out.medecin = line.replace(/^dr\.?\s*/i, '');
        continue;
      }
    }
    reste.push(line);
  }
  if (!out.profession && reste.length) out.profession = reste[0];
  return Object.fromEntries(Object.entries(out).filter(([, v]) => v));
};

export default parsePatientColle;
